/**
 * 服务器信息条组件
 */

import React from 'react';
import { useServerStore } from '@/stores';
import { useIsLightUi } from '@/hooks';
import { serverBarInline, serverIpInline, serverNameInline } from '@/utils/themeInline';

interface ServerBarProps {
  fileManagerOpen?: boolean;
  onToggleFileManager?: () => void;
}

export const ServerBar: React.FC<ServerBarProps> = ({
  fileManagerOpen = false,
  onToggleFileManager,
}) => {
  const { activeServerName, activeServerIp } = useServerStore();
  const isLightUi = useIsLightUi();

  return (
    <div className="sse-ai-server-bar" style={serverBarInline(isLightUi)}>
      <div className="sse-ai-server-info">
        <span className="server-name" style={serverNameInline(isLightUi)}>
          {activeServerName || '服务器'}
        </span>
        <span className="server-ip" style={serverIpInline(isLightUi)}>
          {activeServerIp || '-'}
        </span>
        <span className="status-badge online">在线</span>
      </div>
      {onToggleFileManager && (
        <button
          type="button"
          className={`sse-ai-server-file-btn${fileManagerOpen ? ' is-active' : ''}`}
          onClick={onToggleFileManager}
          title="文件"
          aria-label="文件管理器"
          aria-expanded={fileManagerOpen}
        >
          <span className="dashicons dashicons-portfolio" aria-hidden />
        </button>
      )}
    </div>
  );
};